// SPDX-FileCopyrightText: 2023 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LockResponse } from 'model/reponse/LockResponse';

// what to do after a successful switch
export type LockedActionIntent = 'editProject' | 'resetModel';
export type LockIntent = 'openProject' | LockedActionIntent;

export type LockProject = {
  projectIdToLock?: string;
  projectLockResponse?: LockResponse;
  intent?: LockIntent;
};

export type ProjectedLockedState = {
  showDialog: boolean;
} & LockProject;

const initialState: ProjectedLockedState = {
  showDialog: false,
  intent: 'openProject',
};

export const projectLockedSlice = createSlice({
  name: 'project-locked',
  initialState,
  reducers: {
    showDialog: (state, action: PayloadAction<LockProject>) => {
      state.showDialog = true;
      state.projectIdToLock = action.payload.projectIdToLock;
      state.projectLockResponse = action.payload.projectLockResponse;
      state.intent = action.payload.intent ?? 'openProject';
    },
    closeDialog: state => {
      state.showDialog = false;
    },
  },
});

export const { showDialog, closeDialog } = projectLockedSlice.actions;
export default projectLockedSlice.reducer;
